/* eslint-disable */
export default {
  title: 'Audio',
  input: 'Ingang',
  microphone: 'Microfoon',
  autoAdjustMicLevel: 'Automatisch mijn microfoonniveau aanpassen',
  output: 'Uitgang',
  speakerSource: 'Luidsprekerbron',
  speakerVolume: 'Luidsprekervolume',
  ringtoneSource: 'Bron van beltoon en meldingen',
  ringtoneVolume: 'Volume van beltoon en meldingen',
  ringtones: 'Beltonen',
  noDevices: 'Geen apparaten',
  off: 'Uit',
  noLabel: 'Onbekend apparaat',
  stopRecordDescription:
    'Zeg iets om uw microfoonniveau te controleren ({countDown} seconden)',
  stopPlaybackDescription: 'Uw opname afspelen...',
  startRecordButton: 'Microfoon testen',
  stopRecordButton: 'Opname stoppen',
  stopPlaybackButton: 'Test stoppen',
  startTestButton: 'Luidspreker testen',
  stopTestDescription: 'Voorbeeldgeluid afspelen...',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
